import { TextField, Grid, MenuItem, useTheme, useMediaQuery } from '@mui/material';
import { getControlId } from '@veeva-ctv/utils';
import { FormikProps } from 'formik';
import { SiteApplicationInput } from '@/gql/graphql';
import StandardCountryStateProvinceInput from '@/components/StandardCountryStateProvinceInput';
import { UIOnlyFields } from '@/types';

interface SMOFormProps {
  formik: FormikProps<UIOnlyFields & SiteApplicationInput>;
}

const SMOForm = ({ formik }: SMOFormProps) => {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Grid item xs={12}>
        <TextField
          id={getControlId({ type: 'text', name: 'hasSmoContract' })}
          name="hasSmoContract"
          label="Do you contract with this site?*"
          fullWidth
          select
          inputProps={{ autoComplete: 'one-time-code' }}
          value={formik.values.hasSmoContract}
          error={formik.touched.hasSmoContract && Boolean(formik.errors.hasSmoContract)}
          helperText={formik.touched.hasSmoContract && formik.errors.hasSmoContract}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}>
          {/* The BE schema doesn't support the required FE values so this hack is to make it work with boolean value  */}
          <MenuItem value={true as any}>Yes</MenuItem>
          <MenuItem value={false as any}>No</MenuItem>
          <MenuItem value={false as any}>Not sure</MenuItem>
        </TextField>
      </Grid>

      {typeof formik.values.hasSmoContract !== 'undefined' && (
        <>
          <Grid item xs={12}>
            <TextField
              id={getControlId({ type: 'text', name: 'organizationName' })}
              name="organization"
              label="Organizaton name*"
              fullWidth
              inputProps={{ autoComplete: 'one-time-code' }}
              value={formik.values.organization}
              error={formik.touched.organization && Boolean(formik.errors.organization)}
              helperText={formik.touched.organization && formik.errors.organization}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Grid>

          <StandardCountryStateProvinceInput
            formik={formik}
            stateFieldName="smoState"
            countryFieldName="smoCountry"
            cityFieldName="smoCity"
            addressFieldName="smoAddress1"
            postalCodeFieldName="smoZip"
          />

          <Grid item xs={12}>
            <TextField
              id={getControlId({ type: 'text', name: 'url' })}
              name="url"
              label="Website*"
              fullWidth
              inputProps={{ autoComplete: 'one-time-code' }}
              value={formik.values.url}
              error={formik.touched.url && Boolean(formik.errors.url)}
              helperText={formik.touched.url && formik.errors.url}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              id={getControlId({ type: 'text', name: 'name' })}
              name="name"
              label="Please specify the name of the research site that the SMO is working with*"
              fullWidth
              inputProps={{ autoComplete: 'one-time-code' }}
              value={formik.values.name}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              //fix for long labels to wrap around nicely on mobile and not overlap with the input
              InputLabelProps={{
                sx: { whiteSpace: smDown ? 'normal' : 'wrap', top: smDown ? '-28px' : '-14px' },
              }}
              sx={{ marginTop: smDown ? '32px' : '20px' }}
            />
          </Grid>

          <StandardCountryStateProvinceInput
            formik={formik}
            stateFieldName="stateProvince"
            countryFieldName="country"
            cityFieldName="city"
            addressFieldName="address1"
            postalCodeFieldName="postalCode"
            stateFieldLabel="Site state/province*"
            countryFieldLabel="Site country*"
            cityFieldLabel="Site city*"
            addressFieldLabel="Site address*"
            postalCodeFieldLabel="Site zip/Postal code*"
          />
        </>
      )}
    </>
  );
};

export default SMOForm;
